import { ICON_FLAG_EN, ICON_FLAG_ID, ICON_FLAG_TH, ICON_FLAG_VN } from './image.const'

export const countries = {
  id: {
    name: 'Indonesia',
    languages: {
      id: 'id',
      en: 'en',
    },
    iconFlag: ICON_FLAG_ID,
  },
  ph: {
    name: 'Philippines',
    languages: {
      ph: 'en',
      en: 'en',
    },
    iconFlag: ICON_FLAG_EN,
  },
  th: {
    name: 'Thailand',
    languages: {
      th: 'th',
      en: 'en',
    },
    iconFlag: ICON_FLAG_TH,
  },
  vn: {
    name: 'Vietnam',
    languages: {
      vn: 'vi',
      en: 'en',
    },
    iconFlag: ICON_FLAG_VN,
  },
}

export const LANGUAGES = {
  VN: 'vi-VN',
  TH: 'th-TH',
  ID: 'id-ID',
  EN: 'en-US',
}
